import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types'
import Drawer from '../../Common/Drawer/Drawer';
import * as types from '../../../constants/actionTypes';
import { DATE_FORMAT, supportTicketStatuses } from '../../../constants/constants';
import { actions as supportActions } from '../../../actions/supportActions';
import { actions as fileActions } from '../../../actions/filesActions';
import Notification from '../../Common/Notification';
import TextArea from '../../Common/TextArea';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Toggle from '../../Common/Toggle/Toggle';
import Icon from '../../Common/Icon';
import '../supportConversation.scss';
import Moment from 'moment';

export class CustomerSupportDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            ticket: null,
            reply: "",
            isResolved: false,
            isFormValid: true,
            isLoading: false
        }
    }

    componentDidMount = async () => {
        await this.loadTicket();
    }

    loadTicket = async () => {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.supportActions.loadTicketConversation(this.props.ticketId);
            if (response.type === types.LOAD_TICKET_CONVERSATION_SUCCESS) {
                // add the description of the ticket as the first message
                let ticket = response.payload;
                ticket.messages.push({ 
                    id: 0, 
                    message: ticket.description, 
                    createdDate: ticket.createdDate,
                    userId: ticket.createdByUserId
                });
                // make as resolved?
                const resolved = (ticket.statusId === supportTicketStatuses.Solved) ? true : false;

                this.setState({ ticket: ticket, isResolved: resolved });
            } else if (response.type === types.LOAD_TICKET_CONVERSATION_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    reply = async () => {

        if(!this.state.reply){
            this.setState({ isFormValid : false });
            return;
        }

        try {
            this.setState({ isLoading: true });
            const response = await this.props.supportActions.requestorReply(this.props.ticketId, this.state.reply, this.state.isResolved);
            if (response.type === types.REQUESTOR_REPLY_SUPPORT_TICKET_SUCCESS) {
                Notification("success", "", "Reply successfully sent");
                this.props.onComplete();
                if(this.state.isResolved)
                {
                    this.props.onResolve();
                }
            } else if (response.type === types.REQUESTOR_REPLY_SUPPORT_TICKET_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    updateReply = (e) => {
        this.setState({ reply: e.target.value });
    }

    onResolveChange = (name, checked) => {
        this.setState({ [name]: checked });
    }

    onViewAttachment = (customerFileName) => {
        this.props.fileActions.download(customerFileName);
    }

    render() {

        return (
            <Drawer isWide={false}
                title='Support Ticket'
                onSaveClick={(this.state.ticket && this.state.ticket.isResolved) ? null : this.reply}
                saveText="Reply"
                onCancelClick={this.props.onComplete}
                cancelText={(this.state.ticket && this.state.ticket.isResolved) ? "Close" : "Cancel"}  
            >

                <LoadingIndicator isLoading={this.state.isLoading}>
                    {this.state.ticket &&
                        <div className="support-conversation">
                            <div className="convo-header">
                                <div><strong>Subject</strong>: {this.state.ticket.subject}</div>                      
                            </div>
                            {this.state.ticket.isResolved ?
                                <div className="alert alert-warning text-center">
                                    This ticket has been resolved.
                                </div>
                            :
                                <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                                    <Toggle name="isResolved" text="Resolve this case" checked={this.state.isResolved} onChange={this.onResolveChange} />
                                    <div className="reply-box">
                                        <TextArea 
                                            name="reply" 
                                            label="Response" 
                                            rows={4} 
                                            value={this.state.reply}
                                            onChange={this.updateReply}
                                            maxLength={1000}
                                            isRequired={true}
                                            errorMessage="Response is Required"
                                        />
                                    </div>
                                </form>                            
                            }
  

                            {this.state.ticket.messages && this.state.ticket.messages.length > 0 &&
                                <div className={(this.state.ticket.isResolved) ? "messages-wrapper resolved" : "message-wrapper"}>
                                    {this.state.ticket.messages.map(msg =>
                                        <div key={msg.id}>
                                            {msg.customerFileName &&
                                                <span onClick={() => this.onViewAttachment(msg.customerFileName)}><Icon name="paperclip right" /></span>
                                            }                                            
                                            <div className={this.state.ticket.createdByUserId === msg.userId ? "message to" : "message from"}>{msg.message}</div>    
                                            <div className="datetime">
                                                {this.state.ticket.createdByUserId == msg.userId ? "You @ " : msg.userName + " @ "}
                                                {Moment(msg.createdDate).format(DATE_FORMAT + " h:mm A")}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            }

                        </div>
                    }                
                </LoadingIndicator>
            </Drawer>
        )
    }
}

CustomerSupportDrawer.propTypes = {
    ticketId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    supportActions: PropTypes.object.isRequired,
    fileActions: PropTypes.object.isRequired,
    onResolve: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        supportActions: bindActionCreators(supportActions, dispatch),
        fileActions: bindActionCreators(fileActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(CustomerSupportDrawer);
